

window.onload = pageLoaded;
window.onscroll = scrollFunction;
window.addEventListener('hashchange', checkHash);

class MaterialIcon extends HTMLElement {
    connectedCallback() {
        const name = this.getAttribute("icon"); // z.B. "call", "mail"
        this.innerHTML = `
            <svg class="wx-icon" aria-hidden="true">
                <use href="#wx-icons-${name}"></use>
            </svg>
        `;
    }
}

customElements.define("custom-icon", MaterialIcon);


function pageLoaded() {
    scrollFunction();
    navHover();
    initMobileNav();
    initNavDropdowns();
    initPriceListNav();
    splideSliders();
    feedbackLoop();
    checkHash();


    if (localStorage.getItem('google_maps_consent') === 'true') {
        loadMaps();
    }
}

function scrollFunction() {
    navFixed();
}

function navFixed() {
    const navbar = document.querySelector('.nav-bar');
    if (!navbar) return;

    if (window.pageYOffset >= 0) {
        navbar.classList.add('fixed');
    } else {
        navbar.classList.remove('fixed');
    }
}

function navHover() {
    const navMain = document.querySelector(".nav-bar");
    const level1Items = document.querySelectorAll(".main-menu > .level-1.has-dropdown");

    if (!navMain || level1Items.length === 0) return;

    level1Items.forEach((item) => {
        item.addEventListener("mouseenter", () => {
            navMain.classList.add("hover-active");
            item.classList.add("current-hover");
        });

        item.addEventListener("mouseleave", () => {
            // etwas verzögert, um Zwischenräume zu ermöglichen
            setTimeout(() => {
                if (!item.matches(":hover")) {
                    navMain.classList.remove("hover-active");
                    item.classList.remove("current-hover");
                }
            }, 50);
        });
    });
}

function checkHash() {
    if (!window.location.hash) return;

    const hash = window.location.hash.substring(1); // ohne #
    const target = document.querySelector('.' + CSS.escape(hash));
    if (!target) return;

    const nav = document.querySelector('.nav-bar');
    const navHeight = nav ? nav.offsetHeight : 0;

    const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        navHeight;

    window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
    });
}





function toggleAccordion(headEl) {
    const itemEl = headEl.closest(".accordion-item");
    if (!itemEl) return;

    const listEl = itemEl.closest(".accordion-list");
    if (!listEl) return;

    const contentEl = itemEl.querySelector(".accordion-content");
    if (!contentEl) return;

    const isOpen = itemEl.classList.contains("active");

    // Immer nur eins offen
    listEl.querySelectorAll(".accordion-item.active").forEach((openItem) => {
        if (openItem === itemEl) return;
        openItem.classList.remove("active");
        const openContent = openItem.querySelector(".accordion-content");
        if (openContent) collapseSmooth(openContent);
    });

    if (isOpen) {
        itemEl.classList.remove("active");
        collapseSmooth(contentEl);
    } else {
        itemEl.classList.add("active");
        expandSmooth(contentEl);
    }
}

function expandSmooth(el) {
    // Startzustand
    el.style.transition = "none";
    el.style.overflow = "hidden";
    el.style.height = "0px";

    // Reflow
    el.offsetHeight;

    // Zielhöhe setzen
    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = el.scrollHeight + "px";
    });

    // Nachmessen, wenn Bilder (lazy) nachladen und scrollHeight sich ändert
    const imgs = el.querySelectorAll("img");
    imgs.forEach((img) => {
        if (img.complete) return;
        img.addEventListener(
            "load",
            () => {
                // nur wenn noch offen
                if (el.closest(".accordion-item")?.classList.contains("active")) {
                    el.style.height = el.scrollHeight + "px";
                }
            },
            { once: true }
        );
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);

        // Optional: nach dem Öffnen Höhe auf "auto" setzen,
        // damit spätere Layout-Änderungen nicht abgeschnitten werden.
        if (el.closest(".accordion-item")?.classList.contains("active")) {
            el.style.transition = "none";
            el.style.height = "auto";
            // overflow kannst du hidden lassen oder entfernen:
            // el.style.overflow = "";
        }
    };

    el.addEventListener("transitionend", onEnd);
}

function collapseSmooth(el) {
    // Wenn vorher auf auto: aktuelle Pixelhöhe fixieren
    el.style.transition = "none";
    el.style.overflow = "hidden";

    const current = el.getBoundingClientRect().height;
    el.style.height = current + "px";

    // Reflow
    el.offsetHeight;

    requestAnimationFrame(() => {
        el.style.transition = "height 300ms ease";
        el.style.height = "0px";
    });

    const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        el.removeEventListener("transitionend", onEnd);
        // optional cleanup
        // el.style.overflow = "";
    };

    el.addEventListener("transitionend", onEnd);
}

function splideSliders() {
    initHeaderSlider();
    initGallerySlider();
    initUSPSlider();
    initServiceList();
    initTeamList();
}

function initUSPSlider() {
    const BREAKPOINT = 992; // < 992px = Slider aktiv
    const SELECTOR = '.js-usp-splide';

    document.querySelectorAll(SELECTOR).forEach((container) => {
        // Originalzustand merken (damit Desktop 1:1 wiederhergestellt werden kann)
        const originalHTML = container.innerHTML;

        let splideInstance = null;
        let isBuiltAsSplide = false;

        function buildSplideDom() {
            if (isBuiltAsSplide) return;

            const items = Array.from(container.querySelectorAll('.usp-item'));

            // Root als Splide markieren
            container.classList.add('splide');

            // Track + List
            const track = document.createElement('div');
            track.className = 'splide__track';

            const list = document.createElement('div');
            list.className = 'splide__list';

            // Items zu Slides
            items.forEach((item) => {
                item.classList.add('splide__slide');
                list.appendChild(item);
            });

            track.appendChild(list);

            // Neu zusammensetzen
            container.innerHTML = '';
            container.appendChild(track);

            isBuiltAsSplide = true;
        }

        function restoreOriginalDom() {
            if (!isBuiltAsSplide) return;

            if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
            }

            container.innerHTML = originalHTML;
            container.classList.remove('splide');
            container.classList.add('usp-list');

            isBuiltAsSplide = false;
        }

        function enableSplide() {
            if (splideInstance) return;

            // Splide muss global verfügbar sein (CDN) oder vorher importiert werden
            splideInstance = new Splide(container, {
                type: 'slide',
                perPage: 1,
                perMove: 1,
                gap: '1rem',
                pagination: true,
                arrows: false,
                autoplay: true,
                interval: 5000,
                speed: 1200,
            });

            splideInstance.mount();
        }

        function update() {
            const isMobile = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;

            if (isMobile) {
                buildSplideDom();
                enableSplide();
            } else {
                restoreOriginalDom();
            }
        }

        // Initial
        update();

        // Resize debounce
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(update, 150);
        });
    });
}


function initHeaderSlider() {
    if (document.querySelector('.splide[data-slider="header"]')) {
        document.querySelectorAll('.splide[data-slider="header"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                autoplay: true,
                interval: 5000,
                speed: 1200,
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                drag: true,
                rewind: true,
            }).mount();
        });
    }
}

function initServiceList() {
    const BREAKPOINT = 992; // < 992px = Slider aktiv
    const SELECTOR = '.js-service-splide';

    document.querySelectorAll(SELECTOR).forEach((container) => {
        // Falls initServiceList() mehrfach aufgerufen wird: doppelte Initialisierung verhindern
        if (container.dataset.serviceListInit === '1') return;
        container.dataset.serviceListInit = '1';

        const originalHTML = container.innerHTML;
        const originalClassName = container.className; // enthält auch "service-list {field.layout} ..."

        let splideInstance = null;
        let isBuiltAsSplide = false;

        function buildSplideDom() {
            if (isBuiltAsSplide) return;

            const items = Array.from(container.querySelectorAll('.service-item'));

            // Root wird Splide
            container.classList.add('splide');
            container.classList.remove('service-list');
            container.classList.add('service-list-mobile');

            // Track + List
            const track = document.createElement('div');
            track.className = 'splide__track';

            const list = document.createElement('div');
            list.className = 'splide__list';

            // Items zu Slides machen
            items.forEach((item) => {
                item.classList.add('splide__slide');
                list.appendChild(item);
            });

            track.appendChild(list);

            // Neu zusammensetzen
            container.innerHTML = '';
            container.appendChild(track);

            isBuiltAsSplide = true;
        }

        function enableSplide() {
            if (splideInstance) return;

            splideInstance = new Splide(container, {
                type: 'slide',
                perPage: 1.35,
                perMove: 1,
                arrows: false,
                pagination: true,
                drag: true,
                gap: '1rem',
                speed: 800,
                rewind: false,
                autoplay: false,
                focus: 'center',
                trimSpace: false,
                preloadPages: 2,
            });

            splideInstance.mount();
        }

        function restoreOriginalDom() {
            if (!isBuiltAsSplide) return;

            if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
            }

            // Komplett zurück auf Original (HTML + Klassen)
            container.innerHTML = originalHTML;
            container.className = originalClassName;

            isBuiltAsSplide = false;
        }

        function update() {
            const isMobile = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;

            if (isMobile) {
                buildSplideDom();
                enableSplide();
            } else {
                restoreOriginalDom();
            }
        }

        // Initial
        update();

        // Resize debounce
        let resizeTimer = null;
        window.addEventListener('resize', () => {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(update, 150);
        });
    });
}


function initGallerySlider() {
    if (document.querySelector('.splide[data-slider="gallery"]')) {
        document.querySelectorAll('.splide[data-slider="gallery"]').forEach(function (el) {
            new Splide(el, {
                type: 'loop',
                perPage: 5.5,
                perMove: 1,
                gap: "1rem",
                autoplay: true,
                focus: 'center',
                interval: 5000,
                speed: 1200,
                arrows: true,
                pagination: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                lazyLoad: true,
                preloadPages: 1,
                keyboard: true,
                drag: true,
                trimSpace: false,
                breakpoints: {
                    1400: {
                        perPage: 3.5,
                        arrows: false,
                    },
                    992: {
                        perPage: 2.5,
                        arrows: false,
                    },
                    767: {
                        perPage: 1.5,
                        arrows: false,
                    }
                }
            }).mount();
        });
    }
}

function feedbackLoop() {
    if (typeof gsap === 'undefined') {
        return;
    }
    const track = document.querySelector(".feedback-slider .feedback-track");
    const slider = document.querySelector(".feedback-slider");
    if (!track || !slider) return;

    if (!track.dataset.cloned) {
        const cards = Array.from(track.children);
        cards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.classList.add("feedback-card--clone");
            track.appendChild(clone);
        });
        track.dataset.cloned = "true";
    }

    const totalWidth = track.scrollWidth / 2; // eine Sequenz

    gsap.to(track, {
        x: -totalWidth,
        duration: 60,
        repeat: -1,
        ease: "linear",
        modifiers: {
            x: (x) => {
                const current = parseFloat(x);
                // sorgt für endlosen Loop
                if (current <= -totalWidth) {
                    return "0px";
                }
                return x;
            },
        },
    });

    // Hover pausieren (optional)
    slider.addEventListener("mouseenter", () => gsap.globalTimeline.pause());
    slider.addEventListener("mouseleave", () => gsap.globalTimeline.resume());
}


function initMobileNav() {
    const navBars = document.querySelectorAll('.nav-bar');
    if (!navBars.length) return;

    let scrollY = 0;

    function lockScroll() {
        // schon gelockt? nichts tun
        if (document.body.classList.contains('is-scroll-locked')) return;

        scrollY = window.scrollY || window.pageYOffset;

        document.documentElement.classList.add('is-scroll-locked');
        document.body.classList.add('is-scroll-locked');

        // Fixiert den Body an aktueller Position -> kein Jump
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
    }

    function unlockScroll() {
        if (!document.body.classList.contains('is-scroll-locked')) return;

        document.documentElement.classList.remove('is-scroll-locked');
        document.body.classList.remove('is-scroll-locked');

        // Styles zurücksetzen
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';

        // Zur gespeicherten Position zurück
        window.scrollTo(0, scrollY);
    }

    navBars.forEach(function (navBar) {
        const nav = navBar.closest('.nav') || navBar;
        const toggle = navBar.querySelector('[data-nav-toggle]');
        const menu = navBar.querySelector('[data-nav-menu]');
        if (!toggle || !menu) return;

        toggle.setAttribute('aria-expanded', 'false');

        function openNav() {
            nav.classList.add('open');
            toggle.setAttribute('aria-expanded', 'true');
            lockScroll();
        }

        function closeNav() {
            nav.classList.remove('open');
            toggle.setAttribute('aria-expanded', 'false');

            // nur entsperren, wenn wirklich keine Mobile-Navi mehr offen ist
            const anyOpenNav = document.querySelector('.nav.open');
            if (!anyOpenNav) unlockScroll();
        }

        function toggleNav() {
            if (nav.classList.contains('open')) closeNav();
            else openNav();
        }

        toggle.addEventListener('click', function (e) {
            e.preventDefault();
            toggleNav();
        });

        document.addEventListener('click', function (e) {
            if (!nav.classList.contains('open')) return;
            if (navBar.contains(e.target)) return;
            closeNav();
        });

        document.addEventListener('keydown', function (e) {
            if (!nav.classList.contains('open')) return;
            if (e.key === 'Escape') closeNav();
        });

        menu.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function () {
                if (nav.classList.contains('open')) closeNav();
            });
        });

        const desktopMq = window.matchMedia('(min-width: 1024px)');

        function handleBreakpoint(e) {
            if (e.matches) {
                closeNav();
            }
        }

        handleBreakpoint(desktopMq);

        if (desktopMq.addEventListener) desktopMq.addEventListener('change', handleBreakpoint);
        else desktopMq.addListener(handleBreakpoint);
    });
}


function initNavDropdowns() {
    const navMenus = document.querySelectorAll('[data-nav-menu]');
    if (!navMenus.length) return;
    if (window.innerWidth >= 993) return;

    navMenus.forEach((menu) => {
        const dropdownItems = menu.querySelectorAll('.has-dropdown');

        dropdownItems.forEach((item) => {
            const toggle = item.querySelector('.dropdown-icon');
            const dropdown = item.querySelector('.nav-dropdown');

            if (!toggle || !dropdown) return;

            // initial closed
            item.classList.remove('is-open');
            dropdown.style.height = '0px';

            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = item.classList.contains('is-open');

                // alle anderen schließen
                dropdownItems.forEach((other) => {
                    const otherDropdown = other.querySelector('.nav-dropdown');
                    if (!otherDropdown) return;

                    other.classList.remove('is-open');
                    otherDropdown.style.height = '0px';
                });

                // aktuellen togglen
                if (!isOpen) {
                    item.classList.add('is-open');

                    // WICHTIG: Höhe vom Dropdown selbst (Inhalt)
                    dropdown.style.height = dropdown.scrollHeight + 'px';
                } else {
                    // wenn du "erneut klicken = schließen" willst:
                    item.classList.remove('is-open');
                    dropdown.style.height = '0px';
                }
            });
        });
    });
}



function toggleFooterCol(el) {
    const elementCol = el.closest('.footer-col');
    if (!elementCol) return;

    if (elementCol.classList.contains('logo') || elementCol.classList.contains('company-info')) {
        return;
    }

    const wasOpen = elementCol.classList.contains('open');

    document.querySelectorAll('footer .footer-col.open').forEach((col) => {
        col.classList.remove('open');
    });

    if (!wasOpen) {
        elementCol.classList.add('open');
    }
}



function initPriceListNav() {
    const nav = document.querySelector(".price-list-nav");
    if (!nav) return;

    const priceLists = document.querySelectorAll(".price-list");
    if (priceLists.length === 0) return;

    const navItems = nav.querySelectorAll('a');
    navItems.forEach(listItem => {
        const anchor = listItem.href.split('#')[1];
        listItem.setAttribute('data-anchor', anchor);
    });

    function priceListNavCheckPosition() {
        var triggerY = 0;
        triggerY += document.querySelector('.nav-bar').getBoundingClientRect().height;
        triggerY += document.querySelector('.price-list-nav').getBoundingClientRect().height;

        priceLists.forEach(list => {
            const rect = list.getBoundingClientRect();
            const itemStart = rect.top;
            const itemEnd = rect.bottom;

            if (triggerY >= itemStart && triggerY <= itemEnd) {
                const anchor = list.getAttribute('data-anchor');


                const nav = document.querySelector(".price-list-nav");

                nav.querySelectorAll('a').forEach(element => {
                    element.classList.remove('is-active');
                });

                const activeItem = nav.querySelector('a[data-anchor="' + anchor + '"]');
                activeItem.classList.add('is-active');

                if (window.innerWidth <= 992 && activeItem) {
                    const scroller = activeItem.closest('.price-list-nav .list');
                    if (!scroller) return;

                    const itemRect = activeItem.getBoundingClientRect();
                    const scrollerRect = scroller.getBoundingClientRect();

                    const delta = (itemRect.left - scrollerRect.left) - (scrollerRect.width / 2 - itemRect.width / 2);

                    scroller.scrollTo({
                        left: scroller.scrollLeft + delta,
                        behavior: 'smooth'
                    });
                }


            }
        });
    }

    window.addEventListener("scroll", priceListNavCheckPosition, { passive: true });
    priceListNavCheckPosition();

    function priceListNavLink() {
        const hash = window.location.hash;
        if (!hash) return;

        const anchor = decodeURIComponent(hash.slice(1));
        const priceList = document.querySelector(`.price-list[data-anchor="${CSS.escape(anchor)}"]`);
        if (!priceList) return;

        const navBar = document.querySelector(".nav-bar");
        const priceNav = document.querySelector(".price-list-nav");

        const navBarH = navBar ? navBar.getBoundingClientRect().height : 0;
        const priceNavH = priceNav ? priceNav.getBoundingClientRect().height : 0;

        const targetTop =
            priceList.getBoundingClientRect().top + window.scrollY - navBarH - priceNavH + 1;

        window.scrollTo({
            top: Math.max(0, targetTop),
            behavior: "smooth"
        });

        history.replaceState(
            null,
            document.title,
            window.location.pathname + window.location.search
        );
    }

    window.addEventListener("hashchange", priceListNavLink);
    // auch beim ersten Laden mit Hash:
    priceListNavLink();

}





function loadMaps() {
    const STORAGE_KEY = 'google_maps_consent';

    // Zustimmung merken (damit beim nächsten Seitenaufruf direkt geladen werden kann)
    localStorage.setItem(STORAGE_KEY, 'true');

    // Alle Map-Wrapper laden (falls du mehrere Maps auf einer Seite hast)
    document.querySelectorAll('.google-maps').forEach((mapWrapper) => {
        const uid = mapWrapper.dataset.mapUid;
        const mapContainer = document.getElementById('gmap-' + uid);
        const consentBox = mapWrapper.querySelector('.gm-consent');

        if (!mapContainer || mapContainer.dataset.loaded === '1') return;

        mapContainer.innerHTML = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2600.061281931721!2d9.71245667749433!3d49.332058567255004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4798690e73a631e5%3A0x46ad24e3ba0e9606!2sSMT%20Schmieg%20Metalltechnik%20GmbH!5e0!3m2!1sde!2sde!4v1768236459807!5m2!1sde!2sde" width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;

        mapContainer.dataset.loaded = '1';
        if (consentBox) consentBox.style.display = 'none';
    });
}



function initTeamList() {
    const BREAKPOINT = 992; // < 992px = Slider
    const SELECTOR = '.js-team-splide';

    document.querySelectorAll(SELECTOR).forEach((container) => {
        // Schutz vor mehrfacher Initialisierung
        if (container.dataset.teamInit === '1') return;
        container.dataset.teamInit = '1';

        const originalHTML = container.innerHTML;
        const originalClassName = container.className;

        let splideInstance = null;
        let isSplide = false;

        function buildSplideDom() {
            if (isSplide) return;

            const items = Array.from(container.querySelectorAll('.team-item'));

            container.classList.add('splide');

            const track = document.createElement('div');
            track.className = 'splide__track';

            const list = document.createElement('div');
            list.className = 'splide__list';

            items.forEach((item) => {
                item.classList.add('splide__slide');
                list.appendChild(item);
            });

            track.appendChild(list);
            container.innerHTML = '';
            container.appendChild(track);

            isSplide = true;
        }

        function enableSplide() {
            if (splideInstance) return;

            splideInstance = new Splide(container, {
                type: 'slide',
                perPage: 1,
                gap: '1rem',
                arrows: false,
                pagination: true,
                drag: true,
            });

            splideInstance.mount();
        }

        function destroySplide() {
            if (!isSplide) return;

            if (splideInstance) {
                splideInstance.destroy(true);
                splideInstance = null;
            }

            container.innerHTML = originalHTML;
            container.className = originalClassName;

            isSplide = false;
        }

        function update() {
            const isMobile = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`).matches;

            if (isMobile) {
                buildSplideDom();
                enableSplide();
            } else {
                destroySplide();
            }
        }

        // initial
        update();

        // resize (debounced)
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(update, 150);
        });
    });
}

// Init
document.addEventListener('DOMContentLoaded', () => {
    initTeamList();
});






(function () {
    function safeJsonParse(el, fallback) {
        try {
            const txt = (el && el.textContent) ? el.textContent.trim() : "";
            if (!txt) return fallback;
            return JSON.parse(txt);
        } catch (e) {
            return fallback;
        }
    }

    function initProductDetail(root) {
        const mainEl = root.querySelector("[data-splide-main]");
        const thumbsEl = root.querySelector("[data-splide-thumbs]");
        const variantsJsonEl = root.querySelector("[data-variants-json]");
        const variantImagesJsonEl = root.querySelector("[data-variant-images-json]");

        if (!mainEl || !thumbsEl || typeof Splide === "undefined") return;

        const detailsOut = root.querySelector("[data-variant-details-output]");

        const variants = safeJsonParse(variantsJsonEl, []);
        const variantImages = safeJsonParse(variantImagesJsonEl, []);

        const variantByIndex = new Map((variants || []).map(v => [Number(v.index), v]));
        const imagesByIndex = new Map((variantImages || []).map(v => [Number(v.index), v]));

        // --- Splide init ---
        const main = new Splide(mainEl, {
            type: "slide",
            pagination: false,
            arrows: true,
            drag: true
        });

        const thumbs = new Splide(thumbsEl, {
            direction: 'ttb',
            height: '450px',
            fixedWidth: 90,
            fixedHeight: 67.5,
            gap: 10,
            isNavigation: true,
            pagination: false,
            arrows: false,
            drag: true
        });

        main.sync(thumbs);
        main.mount();
        thumbs.mount();

        // Base slides count (= Produktbilder)
        const baseCount = main.Components.Slides.get().length;

        function removeVariantSlides() {
            // Remove variant slides from end to baseCount (keep product slides)
            for (let i = main.Components.Slides.get().length - 1; i >= baseCount; i--) {
                main.remove(i);
            }
            for (let i = thumbs.Components.Slides.get().length - 1; i >= baseCount; i--) {
                thumbs.remove(i);
            }
        }

        // --- Build DOM nodes (robust across Splide versions) ---
        function buildMainSlideNode(url, alt) {
            const li = document.createElement("li");
            li.className = "splide__slide";
            li.dataset.slideType = "variant";

            const img = document.createElement("img");
            img.src = url;
            img.loading = "lazy";
            img.decoding = "async";
            img.alt = alt || "";

            li.appendChild(img);
            return li;
        }

        function buildThumbSlideNode(url) {
            const li = document.createElement("li");
            li.className = "splide__slide";
            li.dataset.thumbType = "variant";

            const img = document.createElement("img");
            img.src = url;
            img.loading = "lazy";
            img.decoding = "async";
            img.alt = "";

            li.appendChild(img);
            return li;
        }

        function setDetailsAndDownloads(index) {
            const v = variantByIndex.get(Number(index));

            if (!detailsOut) return;

            if (!v) {
                detailsOut.innerHTML = `<p class="muted">Bitte Variante auswählen, um Details zu sehen.</p>`;
                return;
            }

            // Details HTML
            detailsOut.innerHTML = v.detailsHtml
                ? v.detailsHtml
                : `<p class="muted">Für diese Variante sind keine Details hinterlegt.</p>`;
        }

        function applyVariantImages(index) {
            removeVariantSlides();

            const pack = imagesByIndex.get(Number(index));
            const raw = (pack && Array.isArray(pack.images)) ? pack.images : [];

            // IMPORTANT: filter empty slots (your JSON contains empty entries)
            const imgs = raw.filter(img =>
                img &&
                typeof img.url === "string" &&
                img.url.trim().length > 0
            );

            // Debug
            // console.log("applyVariantImages idx:", index, "raw:", raw.length, "filtered:", imgs.length);

            if (!imgs.length) {
                // No variant images => just stay on product images
                main.go(0);
                main.refresh();
                thumbs.refresh();
                return;
            }

            imgs.forEach(img => {
                main.add(buildMainSlideNode(img.url, img.alt));
                thumbs.add(buildThumbSlideNode(img.url));
            });

            main.refresh();
            thumbs.refresh();

            // Debug: confirm slide count increased
            // console.log("After add: main slides =", main.Components.Slides.get().length, "thumb slides =", thumbs.Components.Slides.get().length);

            // Jump to first injected variant slide
            main.go(baseCount);
        }

        function resetToProduct() {
            removeVariantSlides();
            main.refresh();
            thumbs.refresh();
            main.go(0);
        }

        function activateVariant(index) {
            setActiveButton(index);
            applyVariantImages(index);
            setDetailsAndDownloads(index);
        }


        // --- Variant buttons ---
        const btns = Array.from(root.querySelectorAll("[data-variant-btn]"));


        function setVariantNr(text) {
            // besser scopen: nur innerhalb des Produkt-Roots
            root.querySelectorAll(".variant--nr").forEach(el => {
                el.textContent = text || ""; // oder z.B. "—"
            });
        }


        function setActiveButton(activeIndexOrNull) {
            btns.forEach(b => {
                const idx = Number(b.getAttribute("data-variant-index"));
                const active = activeIndexOrNull !== null && idx === Number(activeIndexOrNull);
                b.classList.toggle("is-active", active);
                b.setAttribute("aria-pressed", active ? "true" : "false");
            });
        }

        btns.forEach(btn => {
            btn.addEventListener("click", () => {
                const idx = Number(btn.getAttribute("data-variant-index"));
                const isActive = btn.classList.contains("is-active");

                if (isActive) {
                    // toggle off
                    setActiveButton(null);
                    resetToProduct();
                    setVariantNr("");
                    setDetailsAndDownloads(null);
                } else {
                    setActiveButton(idx);
                    setVariantNr(btn.textContent.trim());
                    applyVariantImages(idx);
                    setDetailsAndDownloads(idx);
                }
            });
        });

        // --- Tabs ---
        const tabsRoot = root.querySelector("[data-tabs]");
        if (tabsRoot) {
            const tabBtns = Array.from(tabsRoot.querySelectorAll("[data-tab-btn]"));
            const panels = Array.from(tabsRoot.querySelectorAll("[data-tab-panel]"));

            function openTab(name) {
                tabBtns.forEach(b => {
                    const active = b.getAttribute("data-tab") === name;
                    b.classList.toggle("is-active", active);
                    b.setAttribute("aria-selected", active ? "true" : "false");
                });
                panels.forEach(p => {
                    const active = p.getAttribute("data-tab-panel") === name;
                    p.classList.toggle("is-active", active);
                    p.hidden = !active;
                });
            }

            tabBtns.forEach(b => b.addEventListener("click", () => openTab(b.getAttribute("data-tab"))));

            // Ensure hidden state matches initial classes
            const initial = (tabBtns.find(b => b.classList.contains("is-active")) || tabBtns[0]);
            if (initial) openTab(initial.getAttribute("data-tab"));
        }

        // Initial state
        if (btns.length && variantByIndex.has(0)) {
            activateVariant(0);
            const btn0 = btns.find(b => Number(b.getAttribute("data-variant-index")) === 0);
            setVariantNr(btn0 ? btn0.textContent.trim() : "");
        } else {
            setVariantNr("");
            setDetailsAndDownloads(null);
        }

    }

    document.addEventListener("DOMContentLoaded", () => {
        document.querySelectorAll("[data-product]").forEach(initProductDetail);
    });
})();



(function () {
    const PRIMARY = "#363537";
    const LOGO_SVG_URL = "/fileadmin/theme/assets/images/logo.svg";

    function onReady(fn) {
        if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
        else fn();
    }

    function sanitizeFilename(name) {
        return (name || "datenblatt")
            .toString()
            .trim()
            .replace(/[\/\\?%*:|"<>]/g, "-")
            .replace(/\s+/g, " ");
    }

    // ✅ Fix: WinAnsi-Probleme vermeiden (⌀ etc.)
    function normalizePdfText(input) {
        return (input || "")
            .replaceAll("⌀", "Ø") // Durchmesser-Symbol
            .replaceAll("\u00A0", " ") // NBSP
            .replaceAll("\u202F", " ") // schmaler NBSP
            .replaceAll("–", "-")
            .replaceAll("—", "-")
            .replaceAll("•", "·");
    }

    function stripHtml(html) {
        if (!html) return "";
        const doc = new DOMParser().parseFromString(html, "text/html");
        return normalizePdfText(
            (doc.body.textContent || "")
                .replace(/\s+\n/g, "\n")
                .replace(/[ \t]+/g, " ")
                .trim()
        );
    }

    function extractKeyValueRows(detailsHtml) {
        if (!detailsHtml) return [];
        const doc = new DOMParser().parseFromString(detailsHtml, "text/html");

        // 1) Tabellen
        const tableRows = [];
        doc.querySelectorAll("table tr").forEach((tr) => {
            const th = tr.querySelector("th");
            const tds = tr.querySelectorAll("td");
            if (th && tds.length) {
                tableRows.push([th.textContent.trim(), tds[0].textContent.trim()]);
            } else if (tds.length >= 2) {
                tableRows.push([tds[0].textContent.trim(), tds[1].textContent.trim()]);
            }
        });
        if (tableRows.length) {
            return tableRows
                .filter((r) => r[0] && r[1])
                .map(([k, v]) => [normalizePdfText(k), normalizePdfText(v)]);
        }

        // 2) Definition lists
        const dlRows = [];
        doc.querySelectorAll("dl").forEach((dl) => {
            const dts = dl.querySelectorAll("dt");
            dts.forEach((dt) => {
                const dd = dt.nextElementSibling;
                if (dd && dd.tagName.toLowerCase() === "dd") {
                    dlRows.push([dt.textContent.trim(), dd.textContent.trim()]);
                }
            });
        });
        if (dlRows.length) {
            return dlRows
                .filter((r) => r[0] && r[1])
                .map(([k, v]) => [normalizePdfText(k), normalizePdfText(v)]);
        }

        // 3) <p><strong>Label:</strong> Wert</p>
        const pRows = [];
        doc.querySelectorAll("p").forEach((p) => {
            const strong = p.querySelector("strong");
            if (!strong) return;
            const label = (strong.textContent || "").trim().replace(/:$/, "");
            const full = (p.textContent || "").trim();
            const value = full.replace(strong.textContent, "").replace(/^:\s*/, "").trim();
            if (label && value) pRows.push([label, value]);
        });
        if (pRows.length) {
            return pRows.map(([k, v]) => [normalizePdfText(k), normalizePdfText(v)]);
        }

        return [];
    }

    async function svgUrlToPngBytes(svgUrl, targetWidthPx = 360) {
        const res = await fetch(svgUrl, { cache: "force-cache" });
        if (!res.ok) throw new Error("Logo konnte nicht geladen werden.");
        const svgText = await res.text();

        const svgBlob = new Blob([svgText], { type: "image/svg+xml" });
        const svgObjectUrl = URL.createObjectURL(svgBlob);

        try {
            const img = await new Promise((resolve, reject) => {
                const i = new Image();
                i.onload = () => resolve(i);
                i.onerror = reject;
                i.src = svgObjectUrl;
            });

            const scale = targetWidthPx / img.width;
            const canvas = document.createElement("canvas");
            canvas.width = Math.max(1, Math.round(img.width * scale));
            canvas.height = Math.max(1, Math.round(img.height * scale));

            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            const dataUrl = canvas.toDataURL("image/png");
            const bin = atob(dataUrl.split(",")[1]);
            const bytes = new Uint8Array(bin.length);
            for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
            return bytes;
        } finally {
            URL.revokeObjectURL(svgObjectUrl);
        }
    }

    function getProductRoot(btn) {
        return btn.closest("[data-product]") || document.querySelector("[data-product]");
    }

    function getVariantsJson(root) {
        const el = root.querySelector("[data-variants-json]");
        if (!el) return [];
        try {
            return JSON.parse(el.textContent.trim());
        } catch {
            return [];
        }
    }

    function getSelectedVariantIndex(root) {
        const pressed = root.querySelector("[data-variant-btn][aria-pressed='true']");
        if (pressed) return Number(pressed.getAttribute("data-variant-index"));

        const active = root.querySelector("[data-variant-btn].is-active");
        if (active) return Number(active.getAttribute("data-variant-index"));

        return -1;
    }

    function wrapText(text, maxWidth, font, size) {
        const words = (text || "").split(/\s+/).filter(Boolean);
        const lines = [];
        let line = "";

        for (const w of words) {
            const test = line ? line + " " + w : w;
            const width = font.widthOfTextAtSize(test, size);
            if (width <= maxWidth) line = test;
            else {
                if (line) lines.push(line);
                line = w;
            }
        }
        if (line) lines.push(line);
        return lines;
    }

    function parseDescriptionBlocks(descriptionHtml) {
        if (!descriptionHtml) return [];
        const doc = new DOMParser().parseFromString(descriptionHtml, "text/html");
        const root = doc.body;

        // Optional: H2 "Produktbeschreibung" raus
        root.querySelectorAll("h2").forEach((h2) => {
            if ((h2.textContent || "").trim().toLowerCase() === "produktbeschreibung") h2.remove();
        });

        const blocks = [];
        const children = Array.from(root.children);

        for (const el of children) {
            const tag = el.tagName.toLowerCase();

            if (tag === "h3") {
                const t = normalizePdfText(el.textContent.trim());
                if (t) blocks.push({ type: "h3", text: t });
                continue;
            }

            if (tag === "p") {
                const t = normalizePdfText(el.textContent.replace(/\s+/g, " ").trim());
                if (t) blocks.push({ type: "p", text: t });
                continue;
            }

            if (tag === "ul" || tag === "ol") {
                const items = Array.from(el.querySelectorAll("li"))
                    .map((li) => normalizePdfText(li.textContent.replace(/\s+/g, " ").trim()))
                    .filter(Boolean);
                if (items.length) blocks.push({ type: "list", items });
                continue;
            }

            // Fallback: sonstigen Kram als Absatz
            const t = normalizePdfText(el.textContent.replace(/\s+/g, " ").trim());
            if (t) blocks.push({ type: "p", text: t });
        }

        return blocks;
    }

    function drawDescriptionBlocks({
        page,
        blocks,
        x,
        y,
        maxWidth,
        fonts,
        colors,
        marginBottom = 10,
    }) {
        const { regular, bold } = fonts;
        const { text, muted, line, primary } = colors;

        const h3Size = 11.5;
        const pSize = 10.5;
        const lh = pSize + 4;
        const h3lh = h3Size + 6;

        const bulletIndent = 12;
        const bulletGap = 6;
        const bullet = "•"; // wird durch normalizePdfText ggf. zu ·, ist ok

        let cursorY = y;

        for (const b of blocks) {
            if (cursorY < 90) break; // Schutz (bei 1 Seite)

            if (b.type === "h3") {
                // kleiner Abstand nach oben, außer am Anfang
                cursorY -= 6;

                page.drawText(b.text, {
                    x,
                    y: cursorY,
                    size: h3Size,
                    font: bold,
                    color: primary,
                });
                cursorY -= h3lh;
                continue;
            }

            if (b.type === "p") {
                const lines = wrapText(b.text, maxWidth, regular, pSize);
                for (const lineText of lines) {
                    if (cursorY < 90) break;
                    page.drawText(lineText, { x, y: cursorY, size: pSize, font: regular, color: text });
                    cursorY -= lh;
                }
                cursorY -= marginBottom;
                continue;
            }

            if (b.type === "list") {
                for (const item of b.items) {
                    if (cursorY < 90) break;

                    // Item-Text umbrechen mit Einzug
                    const itemLines = wrapText(item, maxWidth - bulletIndent, regular, pSize);

                    // Bullet nur in erster Zeile
                    page.drawText(bullet, {
                        x,
                        y: cursorY,
                        size: pSize,
                        font: regular,
                        color: muted,
                    });

                    page.drawText(itemLines[0] || "", {
                        x: x + bulletIndent,
                        y: cursorY,
                        size: pSize,
                        font: regular,
                        color: text,
                    });

                    cursorY -= lh;

                    for (let i = 1; i < itemLines.length; i++) {
                        if (cursorY < 90) break;
                        page.drawText(itemLines[i], {
                            x: x + bulletIndent,
                            y: cursorY,
                            size: pSize,
                            font: regular,
                            color: text,
                        });
                        cursorY -= lh;
                    }

                    cursorY -= 2; // kleine Luft zwischen Bullet-Items
                }
                cursorY -= marginBottom;
                continue;
            }
        }

        return cursorY;
    }

    async function loadImageForPdf(pdfDoc, url) {
        if (!url) return null;

        const res = await fetch(url, { cache: "force-cache" });
        if (!res.ok) return null;

        const bytes = await res.arrayBuffer();

        // jpg / png automatisch erkennen
        if (url.toLowerCase().endsWith(".png")) {
            return await pdfDoc.embedPng(bytes);
        }
        return await pdfDoc.embedJpg(bytes);
    }

    async function generateDatasheetPdf({ productTitle, sku, variantTitle, detailsHtml, descriptionHtml, firstImageUrl }) {
        const PAGE_HEADER_TITLE = normalizePdfText(productTitle || "Datenblatt");
        let LAST_PAGE_HEADER = "";

        const { PDFDocument, StandardFonts, rgb } = window.PDFLib || {};
        if (!PDFDocument) throw new Error("pdf-lib ist nicht geladen.");

        const pdfDoc = await PDFDocument.create();

        // ---- Fonts
        const fontRegular = await pdfDoc.embedFont(StandardFonts.Helvetica);
        const fontBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

        // ---- Colors
        const primary = (() => {
            const hex = PRIMARY.replace("#", "");
            return rgb(
                parseInt(hex.slice(0, 2), 16) / 255,
                parseInt(hex.slice(2, 4), 16) / 255,
                parseInt(hex.slice(4, 6), 16) / 255
            );
        })();
        const text = rgb(0.08, 0.08, 0.09);
        const muted = rgb(0.45, 0.46, 0.49);
        const line = rgb(0.88, 0.88, 0.90);
        const softBg = rgb(0.97, 0.97, 0.98);

        // ---- Page + layout constants
        const PAGE_SIZE = [595.28, 841.89]; // A4
        const margin = 48;

        let page = pdfDoc.addPage(PAGE_SIZE);
        let { width, height } = page.getSize();
        let contentW = width - margin * 2;

        const TOP_Y = height - margin;
        const BOTTOM_Y = margin + 70; // Platz für Footer
        let y = TOP_Y;

        // ---- Logo (optional)
        let logoImg = null;
        try {
            const logoBytes = await svgUrlToPngBytes(LOGO_SVG_URL, 320);
            logoImg = await pdfDoc.embedPng(logoBytes);
        } catch {
            logoImg = null;
        }

        // ---- Footer (auf jeder Seite)
        function drawFooter(p) {
            const footerY = margin - 10;

            p.drawLine({
                start: { x: margin, y: footerY + 18 },
                end: { x: margin + contentW, y: footerY + 18 },
                thickness: 1,
                color: line,
            });

            const now = new Date();
            const dateStr = now.toLocaleDateString("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" });

            p.drawText(`Erstellt am ${normalizePdfText(dateStr)}`, {
                x: margin,
                y: footerY,
                size: 9,
                font: fontRegular,
                color: muted,
            });

            const rightFooter = `www.smt-metalltechnik.de`;
            p.drawText(rightFooter, {
                x: margin + contentW - fontRegular.widthOfTextAtSize(rightFooter, 9),
                y: footerY,
                size: 9,
                font: fontRegular,
                color: muted,
            });
        }

        // ---- kleiner Header auf Folgeseiten (optional)
        function drawPageHeader(headerText) {
            LAST_PAGE_HEADER = headerText || "";

            page.drawText(LAST_PAGE_HEADER, {
                x: margin,
                y: TOP_Y,
                size: 12,
                font: fontBold,
                color: primary,
            });

            page.drawLine({
                start: { x: margin, y: TOP_Y - 12 },
                end: { x: margin + contentW, y: TOP_Y - 12 },
                thickness: 1,
                color: line,
            });

            y = TOP_Y - 26;
        }



        // ---- Page break helper
        function newPage() {
            drawFooter(page);

            page = pdfDoc.addPage(PAGE_SIZE);
            ({ width, height } = page.getSize());
            contentW = width - margin * 2;
            y = TOP_Y;

            drawPageHeader(PAGE_HEADER_TITLE); // ✅ immer Produkttitel
        }


        function ensureSpace(requiredHeight) {
            if (y - requiredHeight >= BOTTOM_Y) return;
            newPage();
        }


        // ---- Section helper
        function drawSectionTitle(title) {
            ensureSpace(60);

            const isDuplicate = (normalizePdfText(LAST_PAGE_HEADER) === normalizePdfText(title));

            // ✅ Wenn der Seitenkopf bereits "Produktdetails" ist, dann NICHT nochmal schreiben
            if (!isDuplicate) {
                page.drawText(title, { x: margin, y, size: 13, font: fontBold, color: primary });
                y -= 10;
            } else {
                // nur kleiner Abstand, damit es nicht "klebt"
                y -= 6;
            }

            page.drawLine({
                start: { x: margin, y },
                end: { x: margin + contentW, y },
                thickness: 1,
                color: line,
            });

            y -= 16;
        }


        async function drawFirstGalleryImage() {
            if (!firstImageUrl) return;

            // viele Setups liefern WebP/currentSrc → fetch + embed kann scheitern
            // deshalb: immer in PNG-Bytes konvertieren (wie beim Logo)
            async function urlToPngBytes(url, targetWidthPx = 1200) {
                const res = await fetch(url, { cache: "force-cache" });
                if (!res.ok) return null;

                const blob = await res.blob();
                const objectUrl = URL.createObjectURL(blob);

                try {
                    const img = await new Promise((resolve, reject) => {
                        const i = new Image();
                        i.crossOrigin = "anonymous";
                        i.onload = () => resolve(i);
                        i.onerror = reject;
                        i.src = objectUrl;
                    });

                    const scale = Math.min(1, targetWidthPx / img.width);
                    const canvas = document.createElement("canvas");
                    canvas.width = Math.max(1, Math.round(img.width * scale));
                    canvas.height = Math.max(1, Math.round(img.height * scale));

                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    const dataUrl = canvas.toDataURL("image/png");
                    const bin = atob(dataUrl.split(",")[1]);
                    const bytes = new Uint8Array(bin.length);
                    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
                    return bytes;
                } catch (e) {
                    return null;
                } finally {
                    URL.revokeObjectURL(objectUrl);
                }
            }

            const pngBytes = await urlToPngBytes(firstImageUrl, 1400);
            if (!pngBytes) return;

            const img = await pdfDoc.embedPng(pngBytes);

            const maxImgHeight = 240;
            const maxImgWidth = contentW;

            const scale = Math.min(maxImgWidth / img.width, maxImgHeight / img.height);
            const drawW = img.width * scale;
            const drawH = img.height * scale;

            ensureSpace(drawH + 24, PAGE_HEADER_TITLE);

            const imgX = margin + (contentW - drawW) / 2;

            page.drawImage(img, {
                x: imgX,
                y: y - drawH,
                width: drawW,
                height: drawH,
            });

            y -= drawH + 24;

            page.drawLine({
                start: { x: margin, y },
                end: { x: margin + contentW, y },
                thickness: 1,
                color: line,
            });

            y -= 18;
        }


        // ---- First page big header
        (function drawFirstHeader() {
            const headerH = 96;

            page.drawRectangle({
                x: margin,
                y: y - headerH,
                width: contentW,
                height: headerH,
                color: softBg,
                borderColor: line,
                borderWidth: 1,
            });

            if (logoImg) {
                const desiredH = 62;
                const scale = desiredH / logoImg.height;
                page.drawImage(logoImg, {
                    x: margin + 18,
                    y: y - 18 - desiredH,
                    width: 140,
                    height: desiredH,
                });
            } else {
                page.drawText("Datenblatt", {
                    x: margin + 18,
                    y: y - 30,
                    size: 16,
                    font: fontBold,
                    color: primary,
                });
            }

            const title = normalizePdfText(productTitle || "Produkt");
            const vTitle = normalizePdfText(variantTitle || "");
            const sub = vTitle ? `Variante: ${vTitle}` : "Variante: –";
            const skuLine = sku ? `Artikel-Nr.: ${normalizePdfText(sku)}` : "";

            const titleSize = 18;
            const subSize = 11;
            const metaSize = 10;

            const rightX = margin + 18 + 240;
            const maxRightW = margin + contentW - rightX - 18;

            const titleLines = wrapText(title, maxRightW, fontBold, titleSize).slice(0, 2);

            let ty = y - 30;
            titleLines.forEach((l) => {
                page.drawText(l, { x: rightX, y: ty, size: titleSize, font: fontBold, color: text });
                ty -= titleSize + 2;
            });

            page.drawText(normalizePdfText(sub), {
                x: rightX,
                y: ty - 2,
                size: subSize,
                font: fontRegular,
                color: primary,
            });
            ty -= subSize + 10;

            if (skuLine) {
                page.drawText(normalizePdfText(skuLine), {
                    x: rightX,
                    y: ty,
                    size: metaSize,
                    font: fontRegular,
                    color: muted,
                });
            }

            // Divider
            y = y - headerH - 18;
            page.drawLine({ start: { x: margin, y }, end: { x: margin + contentW, y }, thickness: 1, color: line });
            y -= 18;


        })();

        await drawFirstGalleryImage();

        // ---- Beschreibung: strukturiert + paged
        const descBlocks = parseDescriptionBlocks(descriptionHtml);
        if (descBlocks.length) {
            drawSectionTitle("Produktbeschreibung");

            const h3Size = 10.5;
            const pSize = 10;
            const lh = pSize + 3;
            const h3lh = h3Size + 4;
            const bulletIndent = 10;
            const bullet = "•";

            for (const b of descBlocks) {
                if (b.type === "h3") {
                    ensureSpace(26, PAGE_HEADER_TITLE);
                    y -= 6;
                    page.drawText(b.text, { x: margin, y, size: h3Size, font: fontBold, color: primary });
                    y -= h3lh;
                    continue;
                }

                if (b.type === "p") {
                    const lines = wrapText(b.text, contentW, fontRegular, pSize);
                    for (const lineText of lines) {
                        ensureSpace(lh + 6, PAGE_HEADER_TITLE);
                        page.drawText(lineText, { x: margin, y, size: pSize, font: fontRegular, color: text });
                        y -= lh;
                    }
                    y -= 10;
                    continue;
                }

                if (b.type === "list") {
                    for (const item of b.items) {
                        const itemLines = wrapText(item, contentW - bulletIndent, fontRegular, pSize);

                        ensureSpace(lh + 8, PAGE_HEADER_TITLE);
                        page.drawText(bullet, { x: margin, y, size: pSize, font: fontRegular, color: muted });
                        page.drawText(itemLines[0] || "", {
                            x: margin + bulletIndent,
                            y,
                            size: pSize,
                            font: fontRegular,
                            color: text,
                        });
                        y -= lh;

                        for (let i = 1; i < itemLines.length; i++) {
                            ensureSpace(lh + 6, PAGE_HEADER_TITLE);
                            page.drawText(itemLines[i], {
                                x: margin + bulletIndent,
                                y,
                                size: pSize,
                                font: fontRegular,
                                color: text,
                            });
                            y -= lh;
                        }

                        y -= 2;
                    }
                    y -= 10;
                }
            }

            y -= 6;
        }

        // ---- Produktdetails: Tabelle paged
        const rows = extractKeyValueRows(detailsHtml);
        const plain = stripHtml(detailsHtml);

        if (rows.length) {
            drawSectionTitle("Produktdetails");

            const colGap = 12;
            const col1W = Math.floor(contentW * 0.42);
            const col2W = contentW - col1W - colGap;

            const labelSize = 10;
            const valueSize = 10;

            const lineHeight = valueSize + 3;
            const padY = 7;
            const afterRowGap = 6;

            for (const [kRaw, vRaw] of rows) {
                const k = normalizePdfText(kRaw);
                const v = normalizePdfText(vRaw);

                const kLines = wrapText(k, col1W, fontBold, labelSize);
                const vLines = wrapText(v, col2W, fontRegular, valueSize);
                const linesCount = Math.max(kLines.length, vLines.length);

                const rowHeight = padY + (linesCount * lineHeight) + padY;

                ensureSpace(rowHeight + 14, PAGE_HEADER_TITLE);

                const rowTop = y;
                const textStartY = rowTop - padY - valueSize;

                for (let i = 0; i < linesCount; i++) {
                    const ty = textStartY - i * lineHeight;

                    if (kLines[i]) {
                        page.drawText(kLines[i], { x: margin, y: ty, size: labelSize, font: fontBold, color: text });
                    }
                    if (vLines[i]) {
                        page.drawText(vLines[i], {
                            x: margin + col1W + colGap,
                            y: ty,
                            size: valueSize,
                            font: fontRegular,
                            color: text,
                        });
                    }
                }

                const rowBottom = rowTop - rowHeight;

                page.drawLine({
                    start: { x: margin, y: rowBottom },
                    end: { x: margin + contentW, y: rowBottom },
                    thickness: 0.8,
                    color: line,
                });

                y = rowBottom - afterRowGap;
            }
        } else if (plain) {
            drawSectionTitle("Produktdetails");

            const size = 10.5;
            const lh = size + 4;
            const lines = wrapText(plain, contentW, fontRegular, size);

            for (const l of lines) {
                ensureSpace(lh + 6, PAGE_HEADER_TITLE);
                page.drawText(l, { x: margin, y, size, font: fontRegular, color: text });
                y -= lh;
            }
        } else {
            drawSectionTitle("Produktdetails");
            page.drawText("Keine Detaildaten vorhanden.", { x: margin, y, size: 10.5, font: fontRegular, color: muted });
            y -= 18;
        }

        // Footer for last page
        drawFooter(page);

        return await pdfDoc.save();
    }


    async function openPdf(bytes, filename) {
        const blob = new Blob([bytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        // 1️⃣ PDF im neuen Tab öffnen (Preview)
        //window.open(url, "_blank", "noopener,noreferrer");

        // 2️⃣ Richtigen Dateinamen setzen (Download)
        const a = document.createElement("a");
        a.href = url;
        a.download = filename; // ✅ HIER der gewünschte Name
        document.body.appendChild(a);
        a.click();
        a.remove();

        // Cleanup
        setTimeout(() => URL.revokeObjectURL(url), 60_000);
    }


    onReady(() => {
        document.addEventListener("click", async (e) => {
            const btn = e.target.closest("[data-datasheet-btn]");
            if (!btn) return;

            e.preventDefault();

            const root = getProductRoot(btn);
            if (!root) return;

            const productTitle = root.getAttribute("data-product-title") || "";
            const skuEl = root.querySelector("[data-product-sku]");
            const sku = skuEl ? skuEl.textContent.trim() : "";

            const variants = getVariantsJson(root);
            const idx = getSelectedVariantIndex(root);

            let variant = null;
            if (variants.length) {
                variant = variants.find((v) => Number(v.index) === Number(idx)) || variants[0];
            }

            const variantTitle = variant?.title || "";
            const detailsHtml = variant?.detailsHtml || "";
            // ✅ Beschreibung robust holen (funktioniert auch, wenn der Selector leicht anders ist)
            const descPanel =
                root.querySelector("[data-tab-panel='desc']") ||
                root.querySelector(".tab-panel[data-tab-panel='desc']") ||
                root.querySelector(".product-tabs [data-tab-panel='desc']");

            const descriptionHtml = descPanel ? descPanel.innerHTML : "";



            try {
                btn.setAttribute("aria-busy", "true");

                // erstes Galeriebild ermitteln
                const firstImgEl = root.querySelector(".product-splide img");
                const firstImageUrl = firstImgEl ? (firstImgEl.currentSrc || firstImgEl.src) : null;

                console.log(firstImageUrl);



                const pdfBytes = await generateDatasheetPdf({
                    productTitle,
                    sku,
                    variantTitle,
                    detailsHtml,
                    descriptionHtml,
                    firstImageUrl,
                });

                const filename = sanitizeFilename(
                    `${normalizePdfText(productTitle)}${variantTitle ? " – " + normalizePdfText(variantTitle) : ""}.pdf`
                );

                await openPdf(pdfBytes, filename);
            } catch (err) {
                console.error(err);
                alert("PDF konnte nicht erstellt werden. Bitte Konsole prüfen.");
            } finally {
                btn.removeAttribute("aria-busy");
            }
        });
    });
})();
